import { useScript } from "@bokio/hooks/useScript/useScript";

export const MicrosoftAds = () => {
	useScript("scripts/microsoftAds.js");

	return null;
};
